(function () {
  const COOKIE_DOMAIN = "{{ config('session.domain') ?? '.nuevocentro.es' }}";

  // --- Utils cookies/localStorage ---
  function setCookie(name, value, days, domain) {
    const maxAge = days * 24 * 60 * 60;
    let cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
    if (location.protocol === 'https:') cookie += '; Secure';
    if (domain) cookie += `; domain=${domain}`;
    document.cookie = cookie;
  }
  function deleteCookie(name, domain) {
    let cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
    if (domain) cookie += `; domain=${domain}`;
    document.cookie = cookie;
  }
  function getCookie(name) {
    const prefix = name + '=';
    return document.cookie.split('; ').find(c => c.startsWith(prefix));
  }
  function hasAcceptedCookies() {
    if (getCookie('cookies_accepted')) return true;
    try { return localStorage.getItem('cookies_accepted') === 'true'; } catch (e) { return false; }
  }

  // --- helper: aplicar decisión y cerrar modal ---
  function commitConsent({ analytics, marketing }) {
    // LocalStorage
    try {
      localStorage.setItem('cookies_analytics', String(analytics));
      localStorage.setItem('cookies_marketing', String(marketing));
      // Marcamos que ya hay decisión (aceptada o denegada)
      localStorage.setItem('cookies_accepted', 'true');
    } catch (e) {}

    // Cookies persistentes (2 años)
    setCookie('cookies_accepted', 'true', 730, COOKIE_DOMAIN);
    setCookie('cookies_analytics', analytics ? 'true' : 'false', 730, COOKIE_DOMAIN);
    setCookie('cookies_marketing', marketing ? 'true' : 'false', 730, COOKIE_DOMAIN);

    // Si se deniega, intenta limpiar cookies conocidas de terceros ya plantadas
    if (!analytics && !marketing) {
      ['_ga','_gid','_gat','_gcl_au','_fbp','_fbq'].forEach(c => {
        deleteCookie(c, COOKIE_DOMAIN);
        deleteCookie(c, window.location.hostname); // por si acaso sin dominio raíz
      });
    }

    // (Opcional) Notifica a tu app/GTM
    try { window.dispatchEvent(new CustomEvent('cookies:change', { detail: { analytics, marketing } })); } catch (e) {}
    if (window.dataLayer) window.dataLayer.push({ event: 'cookies_change', analytics, marketing });

    // Cierra modal
    const modal = document.getElementById('modalCookies');
    if (modal) modal.style.display = 'none';
    const overlay = document.getElementById('overlayCookies');
    if (overlay) overlay.style.display = 'none';
  }

  // --- Handlers para tus 3 botones ---
  window.permitirtodasConfiguracionCookies = function () {
    commitConsent({ analytics: true, marketing: true });
  };
  window.guardarseleccionConfiguracionCookies = function () {
    const form = document.getElementById('cookie-form');
    const analytics = form?.analytics ? !!form.analytics.checked : false;
    const marketing = form?.marketing ? !!form.marketing.checked : false;
    commitConsent({ analytics, marketing });
  };
  window.denegarConfiguracionCookies = function () {
    commitConsent({ analytics: false, marketing: false });
  };

  // --- [Compat] deja el antiguo "Guardar preferencias" apuntando a "Permitir selección"
  window.guardarConfiguracionCookies = window.guardarseleccionConfiguracionCookies;

  // --- Scroll-to-top (sin cambios) ---
  window.onscroll = function () {
    const btn = document.querySelector(".scroll-to-top");
    if (!btn) return;
    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
      btn.style.display = "block";
    } else {
      btn.style.display = "none";
    }
  };
  window.scrollToTop = function () { window.scrollTo({ top: 0, behavior: 'smooth' }); };

  // --- Lógica de apertura manual/automática (casi igual) ---
  document.addEventListener('DOMContentLoaded', function () {
    const btnCookies = document.getElementById('btn-config-cookies');
    const modal = document.getElementById('modalCookies');
    const form = document.getElementById('cookie-form');

    function preloadChecks() {
      if (!form) return;
      try {
        if (form.analytics) form.analytics.checked = (localStorage.getItem('cookies_analytics') === 'true');
        if (form.marketing) form.marketing.checked = (localStorage.getItem('cookies_marketing') === 'true');
      } catch (e) {}
    }
    function openCookiesModal() {
      preloadChecks();
      if (modal) modal.style.display = 'block';
      const overlay = document.getElementById('overlayCookies');
      if (overlay) overlay.style.display = 'block';
    }

    if (btnCookies) btnCookies.addEventListener('click', openCookiesModal);
    if (!hasAcceptedCookies()) openCookiesModal();
  });
})();
